import { withTranslation } from "react-i18next";
import TourLineBulkCreate from './TourLineBulkCreate';

export default withTranslation()(TourLineBulkCreate);